import "./FormClient.css";
import React, { useState, useEffect } from "react";
import { Form, InputGroup, Col, Container, Row } from "react-bootstrap";
import { CalendarDaysIcon } from "@heroicons/react/24/outline";
import { PatternFormat, NumericFormat } from "react-number-format";
import useStore from "../../../Zustand/Zustand";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const FormClient = () => {
  const {
    rendaMensalClient,
    setRendaMensalClient,
    setIdadeCliente,
    setNumero,
    setNomeCompleto,
    idadeCliente,
    setEmailPrincipal,
    nomeCompleto,
    emailPrincipal,
    numero,
    setCpf,
    cpf,
    numeroIsErro,
    setManagerError,
    managerErro,
    setRendaMensalIsErro,
    rendaMensalIsErro,
    nomeCompletoIsErro,
    emailPrincipalIsErro,
    nascimentoIsErro,
    setNomeCompletoIsErro,
    setNascimentoIsErro,
    cpfIsErro,
    setNumeroIsErro,
    setEmailPrincipalIsErro,
    setCpfIsErro,
  } = useStore();

  const Link = ({ id, children, title }) => (
    <OverlayTrigger overlay={<Tooltip id={id}>{title}</Tooltip>}>
      <a href="#/">{children}</a>
    </OverlayTrigger>
  );

  const validateForm = () => {
    const isNomeValido = nomeCompleto.length >= 10;
    const isEmailValido = validarEmail(emailPrincipal);
    const isIdadeValida = calcularIdadeTrueOrFalse(idadeCliente);
    const isCpfValido = validarCPF(cpf);
    const isRendaValida = rendaMensalClient >= 1000.0;
    const isNumeroValido = numero.length >= 10;

    const isFormValid =
      isNomeValido &&
      isEmailValido &&
      isIdadeValida &&
      isCpfValido &&
      isRendaValida &&
      isNumeroValido;

    setManagerError(!isFormValid);
  };

  const validarEmail = (email) => {
    const regex = /^[^\s@]+@[^@\s]+\.[^\s@]{2,}$/;
    return regex.test(email);
  };

  const validarCPF = (cpf) => {
    cpf = cpf.replace(/[^\d]+/g, "");

    if (cpf.length !== 11) return false;

    if (/^(\d)\1{10}$/.test(cpf)) return false;

    let soma = 0;
    let resto;

    for (let i = 1; i <= 9; i++) {
      soma += parseInt(cpf.substring(i - 1, i), 10) * (11 - i);
    }
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(9, 10), 10)) return false;
    soma = 0;
    for (let i = 1; i <= 10; i++) {
      soma += parseInt(cpf.substring(i - 1, i), 10) * (12 - i);
    }
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(10, 11), 10)) return false;

    return true;
  };

  function calcularIdadeTrueOrFalse(dataNascimento) {
    if (dataNascimento.length !== 8 || isNaN(dataNascimento)) {
      return false;
    }

    const dia = parseInt(dataNascimento.substring(0, 2), 10);
    const mes = parseInt(dataNascimento.substring(2, 4), 10);
    const ano = parseInt(dataNascimento.substring(4, 8), 10);

    const nascimento = new Date(ano, mes - 1, dia);
    const hoje = new Date();

    let idade = hoje.getFullYear() - nascimento.getFullYear();
    const mesAtual = hoje.getMonth() + 1;
    const diaAtual = hoje.getDate();

    if (mesAtual < mes || (mesAtual === mes && diaAtual < dia)) {
      idade--;
    }

    return idade >= 18 && idade <= 100;
  }

  useEffect(() => {
    validateForm();
  }, [
    nomeCompleto,
    emailPrincipal,
    idadeCliente,
    cpf,
    rendaMensalClient,
    numero,
  ]);

  useEffect(() => {
    if (numero.length > 1) {
      setNumeroIsErro(false);
    }
  }, [numero]);

  useEffect(() => {
    if (nomeCompleto.length > 1) {
      setNomeCompletoIsErro(false);
    }
  }, [nomeCompleto]);
  useEffect(() => {
    if (rendaMensalClient > 1000) {
      setRendaMensalIsErro(false);
    }
  }, [rendaMensalClient]);

  useEffect(() => {
    if (emailPrincipal.length > 1) {
      setEmailPrincipalIsErro(false);
    }
  }, [emailPrincipal]);

  useEffect(() => {
    if (idadeCliente.length > 1) {
      setNascimentoIsErro(false);
    }
  }, [idadeCliente]);
  useEffect(() => {
    if (cpf.length > 1) {
      setCpfIsErro(false);
    }
  }, [cpf]);

  return (
    <section>
      <Container className="mx-0">
        <Row className="d-flex align-items-start flex-wrap">
          <Col xs={12} md={6} lg={5} className="mb-3">
            <Form.Group controlId="validationCustom01">
              <Form.Label className="label">
                Nome completo
                <InputGroup>
                  <Form.Control
                    type="text"
                    minLength={3}
                    maxLength={100}
                    required
                    onChange={(event) => {
                      const valor = event.target.value;
                      const valorFiltrado = valor.replace(/[^a-zA-ZÀ-ÿ\s]/g, "");
                      setNomeCompleto(valorFiltrado);
                    }}
                    value={nomeCompleto}
                  />
                </InputGroup>
                {((nomeCompleto.length <= 10 && nomeCompleto !== "") ||
                  nomeCompletoIsErro) && (
                    <p
                      className="text-danger m-0 p-0 mt-1"
                      style={{ fontSize: "12px" }}
                    >
                      Digite o seu nome completo
                    </p>
                  )}
              </Form.Label>
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={5} className="mb-3">
            <Form.Label className="label">
              Email Principal
              <InputGroup>
                <Form.Control
                  type="email"
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                  value={emailPrincipal}
                  onChange={(event) => setEmailPrincipal(event.target.value)}
                />
              </InputGroup>
              {((!validarEmail(emailPrincipal) && emailPrincipal !== "") ||
                emailPrincipalIsErro) && (
                  <p
                    className="text-danger m-0 p-0 mt-1"
                    style={{ fontSize: "12px" }}
                  >
                    Email inválido
                  </p>
                )}
            </Form.Label>
          </Col>
        </Row>

        <Row className="d-flex align-items-start flex-wrap">
          <Col xs={12} md={4} lg={4} xl={3} className="mb-3">
            <Form.Label className="label">
              <div className="d-flex align-items-center justify-content-start gap-1">
                Nascimento
                <Link id="t-2" title="A idade deve estar entre 18 e 80 anos.">
                  <InformationCircleIcon
                    strokeWidth={2}
                    style={{
                      width: "15px",
                      paddingBottom: "2px",
                      border: "10px",
                      color: "#555af8",
                    }}
                  />
                </Link>
              </div>

              <InputGroup>
                <InputGroup.Text className="bg-white">
                  <CalendarDaysIcon
                    style={{
                      height: "24px",
                      width: "24px",
                      color: "rgba(0, 0, 0, 0.5)",
                    }}
                  />
                </InputGroup.Text>

                <PatternFormat
                  format="##/##/####"
                  placeholder="dd/mm/aaaa"
                  value={idadeCliente}
                  onValueChange={(event) => setIdadeCliente(event.value)}
                  customInput={Form.Control}
                />
              </InputGroup>
              {((idadeCliente.length <= 10 &&
                !calcularIdadeTrueOrFalse(idadeCliente) &&
                idadeCliente != "") ||
                nascimentoIsErro) && (
                  <p
                    className="text-danger m-0 p-0 mt-1"
                    style={{ fontSize: "12px" }}
                  >
                    Data inválida
                  </p>
                )}
            </Form.Label>
          </Col>

          <Col md={4} lg={4} xl={3} className="mb-3">
            <Form.Label className="label">
              CPF
              <InputGroup>
                <PatternFormat
                  format="###.###.###-##"
                  placeholder="000.000.000-00"
                  value={cpf}
                  onValueChange={(values) => setCpf(values.value)}
                  customInput={Form.Control}
                />
              </InputGroup>
              {((!validarCPF(cpf) && cpf !== "") || cpfIsErro) && (
                <p
                  className="text-danger m-0 p-0 mt-1"
                  style={{ fontSize: "12px" }}
                >
                  CPF inválido
                </p>
              )}
            </Form.Label>
          </Col>

          <Col xs={12} md={6} lg={3} className="mb-3">
            <Form.Label className="label">
              <div className="d-flex align-items-center justify-content-start gap-1">
                Renda Mensal
              </div>
              <InputGroup>
                <NumericFormat
                  className="form-control"
                  placeholder="R$ 0,00"
                  allowNegative={false}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale
                  prefix="R$ "
                  onValueChange={(values) =>
                    setRendaMensalClient(values.value || "")
                  }
                  value={rendaMensalClient}
                  customInput={Form.Control}
                />
              </InputGroup>
              {((rendaMensalClient < 1000 && rendaMensalClient != 0) ||
                rendaMensalIsErro) && (
                  <p
                    className="text-danger m-0 p-0 mt-1"
                    style={{ fontSize: "12px" }}
                  >
                    Renda inválida
                  </p>
                )}
            </Form.Label>
          </Col>
          <Col xs={12} md={6} lg={3} className="mb-3">
            <Form.Label className="label">
              Celular
              <InputGroup>
                <PatternFormat
                  format="(##) #####-####"
                  mask="_"
                  placeholder="(00) 00000-0000"
                  allowEmptyFormatting={true}
                  value={numero}
                  onValueChange={(values) => setNumero(values.value)}
                  className="form-control"
                />
              </InputGroup>
              {((numero.length <= 10 && numero !== "") || numeroIsErro) && (
                <p
                  className="text-danger m-0 p-0 mt-1"
                  style={{ fontSize: "12px" }}
                >
                  Número inválido
                </p>
              )}
            </Form.Label>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FormClient;
